const PANMONEY_EXTENDED = 'https://raw.githubusercontent.com/briannichols0702/token-list/09a578cae234a3c6d78002aae7bebc88fa4698e6/pancakeswap-extended.jsn'
const PANMONEY_TOP100 = 'https://raw.githubusercontent.com/briannichols0702/token-list/09a578cae234a3c6d78002aae7bebc88fa4698e6/pancakeswap-extended.jsn'

export const UNSUPPORTED_LIST_URLS: string[] = []

// lower index == higher priority for token import
export const DEFAULT_LIST_OF_LISTS: string[] = [
  PANMONEY_TOP100,
  PANMONEY_EXTENDED,
  ...UNSUPPORTED_LIST_URLS, // need to load unsupported tokens as well
]

// default lists to be 'active' aka searched across
export const DEFAULT_ACTIVE_LIST_URLS: string[] = []
